/* tslint:disable:max-classes-per-file */
import React from 'react';
import { Utils } from '@singularsystems/neo-core';
import { Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { AppService, Types } from '../../Services/AppService';
import { contactUsRoute, dashboardRoute, faqRoute, IAppMenuItem, investorProfileRoute } from '../../Services/RouteService';
import Dashboard from "../../Views/Dashboard/Dashboard";

@observer
export default class Sidebar extends React.Component {

    private investorService = AppService.get(Types.Services.CurrentInvestorService);
    private routingState = AppService.get(Types.Neo.Routing.GlobalRoutingState);
    private appLayout = AppService.get(Types.Services.AppLayout);

    public render() {

        return (
            <div className={Utils.joinWithSpaces("sidebar", this.appLayout.showMobileMenu ? "show" : "")} onClick={() => this.appLayout.showMobileMenu = false}>
                <div className="sidebar-overlay" />
                <div className="sidebar-menu">

                    {this.renderMenuItem(dashboardRoute, Dashboard)}
                    {this.renderMenuItem(investorProfileRoute)}
                    {this.renderMenuItem(faqRoute)}
                    {this.renderMenuItem(contactUsRoute)}
                </div>
                
            </div>
            
        );
    }

    private renderMenuItem(menuItem: IAppMenuItem, component?: any) {
        const currentRoute = this.routingState.currentRoute;
        const isSelected =currentRoute?.path === menuItem.path || currentRoute?.route.component === component;
        
        if (menuItem.requiresReadyInvestor && !this.investorService.investorData?.readyToInvest) {
            return null;
        }

        return (
            <Neo.Tooltip content={menuItem.name} position="right">
                <Neo.Link to={menuItem.path!}>
                    <div className={"sidebar-menu-item" + (isSelected ? " active" : "")}>
                        <div className="sidebar-menu-icon">
                            <i className={Utils.getFontAwesomeClass(menuItem.icon!)} /> 
                        </div>
                        <div className="sidebar-menu-name">
                            {menuItem.name}
                        </div>
                    </div>
                </Neo.Link>
            </Neo.Tooltip>)
    }
}